var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAusrichtenM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ausrichten_M__Icn/40px/Ausrichten_M",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ausrichten_M__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Ausrichten_M__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12,16 L28,16 L28,18 L12,18 Z M9,11 L31,11 L31,13 L9,13 Z M16,21 L24,21 L24,23 L16,23 Z M11,26 L29,26 L29,28 L11,28 Z",
    id: ".._.._src_svg_Icn_40px_Ausrichten_M__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAusrichtenM);
export default __webpack_public_path__ + "static/media/Ausrichten_M.e87fa65057b15a05fc9f0c61faf19345.svg";
export { ForwardRef as ReactComponent };